import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import it from 'vuetify/src/locale/it';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: colors.blue.darken3,
                secondary: colors.red,
                accent: colors.green.darken1,
            },
        }
    },
    lang: {
        locales: { it },
        current: process.env.VUE_APP_I18N_LOCALE,
    },
});

